// Lib
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Utils
import delay from '../../../../../../../../common/utils/lib/delay';
import {
    getIsPublishedMediaDownloadDisabled,
    getTitle,
} from '../../../../../../../../common/elements/utils/elementPropertyUtils';

// Actions
import { updateElement } from '../../../../../../../../common/elements/elementActions';

// Components
import ToggleInput from '../../../../../../../components/form/fields/ToggleInput';
import TooltipSource from '../../../../../../../components/tooltips/TooltipSource';
import SettingsRow from '../../../../../../../user/account/accountModal/components/SettingsRow';

// Constants
import { TIMES } from '../../../../../../../../common/utils/timeUtil';
import { TooltipPositions } from '../../../../../../../components/tooltips/tooltipConstants';

const mapDispatchToProps = (dispatch) => ({
    dispatchUpdateElement: (args) => dispatch(updateElement(args)),
});

const PublishBoardDownloadFilesToggle = (props) => {
    const {
        isPublished,
        canModifySettings,
        currentBoard,
        currentBoardId,
        dispatchUpdateElement,
        showSharedAncestorBoardLink,
        publishedAncestorBoard,
    } = props;

    // Default to enabled, unless specifically disabled
    const [downloadFilesDisabled, setdownloadFilesDisabled] = useState(
        getIsPublishedMediaDownloadDisabled(currentBoard) !== true,
    );
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const onToggleFeedback = async (event) => {
        const nowDisabled = event.target.checked;

        setIsLoading(true);
        setdownloadFilesDisabled(nowDisabled);

        try {
            await dispatchUpdateElement({
                id: currentBoardId,
                changes: {
                    publishedMediaDownloadDisabled: downloadFilesDisabled,
                },
                sync: true,
            });
        } catch (err) {
            setError(err);

            await delay(1000);

            setdownloadFilesDisabled(!nowDisabled);
            setError(null);
        }

        setIsLoading(false);
    };

    return (
        <div className="PublishBoardDownloadFilesToggle">
            <SettingsRow
                loading={isLoading}
                className="secondary-row"
                disabled={!isPublished}
                label="Show download links on files"
            >
                <TooltipSource
                    className="share-link-toggle-tooltip small-text"
                    enabled={!!showSharedAncestorBoardLink}
                    triggerOnClick
                    position={TooltipPositions.BOTTOM}
                    duration={TIMES.SECOND * 3}
                    tooltipText={`Change this setting in: ${getTitle(publishedAncestorBoard)}`}
                >
                    <ToggleInput
                        error={!!error}
                        disabled={!canModifySettings}
                        active={downloadFilesDisabled}
                        onChange={onToggleFeedback}
                    />
                </TooltipSource>
            </SettingsRow>
        </div>
    );
};

PublishBoardDownloadFilesToggle.propTypes = {
    isPublished: PropTypes.bool,
    canModifySettings: PropTypes.bool,
    showSharedAncestorBoardLink: PropTypes.bool,

    currentBoardId: PropTypes.string,
    currentBoard: PropTypes.object,
    publishedAncestorBoard: PropTypes.object,

    dispatchPublishBoard: PropTypes.func,
    dispatchUpdateElement: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(PublishBoardDownloadFilesToggle);
